/* eslint-disable @typescript-eslint/camelcase */
import get from 'lodash/get';

const ADVISER_ROLE = 2;

const email = get(ADV, 'data.user.Email', null);
const firstName = get(ADV, 'data.user.FirstName', null);
const lastName = get(ADV, 'data.user.LastName', null);
const organizationName = get(ADV, 'data.user.OrganizationName', null);
const role = get(ADV, 'data.user.Role', null);

const orionFirmId = get(ADV, 'data.user.OrionFirmId', null);
const orionUserId = get(ADV, 'data.user.OrionUserId', null);
const createdOn = get(ADV, 'data.user.CreatedOn', null);
const numberOfAdvisers = get(ADV, 'data.user.NumberOfAdvisers', null);

const { aptrinsic } = window;
const isAdviser = role === ADVISER_ROLE;
const isPresentationMode = get(ADV, 'info.isPresentationMode', false);

if (aptrinsic) {
  aptrinsic('reset');
}

// GAINSIGHT
if (aptrinsic && (orionUserId || get(ADV, 'data.user.OrionAdviserUserId', null)) && isAdviser) {
  const gainsightUserProps = isPresentationMode
    ? {
        id: get(ADV, 'data.user.OrionAdviserUserId', null),
        email: get(ADV, 'data.user.OrionAdviserEmail', null),
        firstName: get(ADV, 'data.user.OrionAdviserFirstName', null),
        lastName: get(ADV, 'data.user.OrionAdviserLastName', null),
        accountId: get(ADV, 'data.user.OrionAdviserFirmId', null),
        signUpDate: get(ADV, 'data.user.OrionAdviserCreatedOn', null),
      }
    : {
        id: orionUserId,
        email,
        firstName,
        lastName,
        accountId: orionFirmId,
        signUpDate: createdOn,
      };

  const gainsightAccountProps = isPresentationMode
    ? {
        id: get(ADV, 'data.user.OrionAdviserFirmId', null),
        name: get(ADV, 'data.user.OrionAdviserFirmName', null),
        numberOfUsers: get(ADV, 'data.user.OrionNumberOfAdvisers', null),
      }
    : {
        id: orionFirmId,
        name: organizationName,
        numberOfUsers: numberOfAdvisers,
      };

  aptrinsic('identify', gainsightUserProps, gainsightAccountProps);
}
